import { Form, Input, } from 'antd'
import TextArea from 'antd/es/input/TextArea';
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';

function SizesForm({ onFinish, editingSizes, setEditingSizes, form }) {
    const { t } = useTranslation();

    useEffect(() => {
        if (editingSizes) {
            form.setFieldsValue(editingSizes);
        } else {
            form.resetFields();
        }
    }, [editingSizes]);

    return (
        <div>
            <Form
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                form={form}
                onFinish={onFinish}
                requiredMark="optional"
            >
                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: t("size_name_pattern_msg"),
                            pattern: /^(?=.{1,10}$)[a-zA-Z ,.'-]+$/i,
                        },
                    ]}
                    label={
                        <span className="flex items-center gap-1">
                            {t("vd_ps_Size_n")}
                            <span className="text-red-500">*</span>
                        </span>
                    }
                    name="size_name"
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: t("size_name_arabic_pattern_msg"),
                            pattern: /^[\u0600-\u06FF ,.'-]+$/i,
                        },
                    ]}
                    label={
                        <span className="flex items-center gap-1">
                            {t("size_arabic")}
                            <span className="text-red-500">*</span>
                        </span>
                    }
                    name="size_name_ar"
                >
                    <Input />
                </Form.Item>

                <button
                    className="btn btn-primary w-full rounded-md text-white"
                    type="submit"
                >
                    {editingSizes ? t("Update") : t("vd_pc_btn")}
                </button>
            </Form>

        </div>
    )
}

export default SizesForm;
